// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResourceBookmark_wrapper"};